import React from 'react';
import { PropertyGroup } from '../PropertyGroup';
import { PropertyNumber } from '../property-types/PropertyNumber';
import { PropertyColor } from '../property-types/PropertyColor';
import { PropertySelect } from '../property-types/PropertySelect';

interface BorderData {
  borderWidth: number;
  borderColor: string;
  borderStyle: string;
  borderRadius: number;
}

interface BorderGroupProps {
  border: BorderData;
  onBorderChange: (property: keyof BorderData, value: string | number) => void;
}

const BORDER_STYLE_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'solid', label: 'Solid' },
  { value: 'dashed', label: 'Dashed' },
  { value: 'dotted', label: 'Dotted' },
  { value: 'double', label: 'Double' },
];

export const BorderGroup: React.FC<BorderGroupProps> = ({
  border,
  onBorderChange
}) => {
  return (
    <PropertyGroup title="Border">
      {/* Border Width */}
      <div className="flex items-center gap-2 py-0.5 mt-1">
        <span className="text-gray-900 dark:text-white text-sm font-medium w-[30%] flex-shrink-0">Width</span>
        <div className="flex flex-1 gap-2">
          <PropertyNumber
            label=""
            value={border.borderWidth}
            onChange={(value) => onBorderChange('borderWidth', value)}
            step={1}
            min={0}
            max={50}
            suffix="px"
          />
        </div>
      </div>

      {/* Border Style */}
      <div className="flex items-center gap-2 py-0.5">
        <span className="text-gray-900 dark:text-white text-sm font-medium w-[30%] flex-shrink-0">Style</span>
        <div className="flex flex-1 gap-2">
          <PropertySelect
            label=""
            value={border.borderStyle}
            options={BORDER_STYLE_OPTIONS}
            onChange={(value) => onBorderChange('borderStyle', value)}
          />
        </div>
      </div>

      {/* Border Color */}
      <div className="flex items-center gap-2 py-0.5">
        <span className="text-gray-900 dark:text-white text-sm font-medium w-[30%] flex-shrink-0">Color</span>
        <div className="flex flex-1 gap-2">
          <PropertyColor
            label=""
            value={border.borderColor}
            onChange={(value) => onBorderChange('borderColor', value)}
          />
        </div>
      </div>

      {/* Border Radius */}
      <div className="flex items-center gap-2 py-0.5">
        <span className="text-gray-900 dark:text-white text-sm font-medium w-[30%] flex-shrink-0">Radius</span>
        <div className="flex flex-1 gap-2">
          <PropertyNumber
            label=""
            value={border.borderRadius}
            onChange={(value) => onBorderChange('borderRadius', value)}
            step={1}
            min={0}
            max={500}
            suffix="px"
          />
        </div>
      </div>
    </PropertyGroup>
  );
};

